export default {
  pt: {
    'shipments.shipmentKanban.noDriver': 'Sem motorista',
    'shipments.shipmentKanban.invoiceSuffix': ' · NF {{invoice}}',
    'shipments.shipmentKanban.status.draft': 'Rascunho',
    'shipments.shipmentKanban.status.awaiting_harvest': 'Aguardando colheita',
    'shipments.shipmentKanban.status.loading': 'Carregando',
    'shipments.shipmentKanban.status.awaiting_invoice': 'Aguardando nota fiscal',
    'shipments.shipmentKanban.status.awaiting_unload': 'Aguardando descarga',
    'shipments.shipmentKanban.status.unloading': 'Em descarga',
    'shipments.shipmentKanban.status.released': 'Liberada',
    'shipments.shipmentKanban.status.cancelled': 'Cancelada',
  },
  en: {
    'shipments.shipmentKanban.noDriver': 'No driver',
    'shipments.shipmentKanban.invoiceSuffix': ' · Invoice {{invoice}}',
    'shipments.shipmentKanban.status.draft': 'Draft',
    'shipments.shipmentKanban.status.awaiting_harvest': 'Awaiting harvest',
    'shipments.shipmentKanban.status.loading': 'Loading',
    'shipments.shipmentKanban.status.awaiting_invoice': 'Awaiting invoice',
    'shipments.shipmentKanban.status.awaiting_unload': 'Awaiting unloading',
    'shipments.shipmentKanban.status.unloading': 'Unloading',
    'shipments.shipmentKanban.status.released': 'Released',
    'shipments.shipmentKanban.status.cancelled': 'Cancelled',
  },
  es: {
    'shipments.shipmentKanban.noDriver': 'Sin conductor',
    'shipments.shipmentKanban.invoiceSuffix': ' · Factura {{invoice}}',
    'shipments.shipmentKanban.status.draft': 'Borrador',
    'shipments.shipmentKanban.status.awaiting_harvest': 'Esperando cosecha',
    'shipments.shipmentKanban.status.loading': 'Cargando',
    'shipments.shipmentKanban.status.awaiting_invoice': 'Esperando factura',
    'shipments.shipmentKanban.status.awaiting_unload': 'Esperando descarga',
    'shipments.shipmentKanban.status.unloading': 'En descarga',
    'shipments.shipmentKanban.status.released': 'Liberada',
    'shipments.shipmentKanban.status.cancelled': 'Cancelada',
  },
}
